export const calculatedAvailableSpend = (
  totalValue: number,
  margin: number,
  variations: number,
  offset: number
) => {
  return totalValue - margin + variations - offset;
};

export const calcRequiredSpend = (
  deemedLabourRatioPercent: number,
  totalSpendAvailable: number
) => {
  const deemedLabourRatio = deemedLabourRatioPercent / 100;
  return totalSpendAvailable - deemedLabourRatio * totalSpendAvailable;
};

export const calcRequiredDeemedHours = (
  availableSpend: number,
  deemedLabourRatio: number,
  deemedLabourHourlyRate: number
) => {
  if (deemedLabourHourlyRate == 0) {
    return 0;
  }
  return (availableSpend * deemedLabourRatio) / 100 / deemedLabourHourlyRate;
};
